"use strict";
// Automations (Flow): trigger → conditions → actions, owned by the site owner.
// Host-only (no app code): studio listens to the events below, enqueues a run
// per matching automation and executes the steps with retries
// (apps/studio/src/modules/plugins/automations). Plugin triggers sent through
// the Plugin API (POST /events/:trigger) go straight to the enqueue path, not
// through the bus, so they need no declaration here.
//
// Contract: @dunea/plugin-sdk primitives/automations.ts.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTOMATIONS_PLUGIN = exports.AUTOMATION_BUS_TRIGGERS = void 0;
/** Bus events an owner can build an automation on. */
exports.AUTOMATION_BUS_TRIGGERS = [
    'core.app.published',
    'shop.order.paid',
    'shop.order.fulfilled',
    'shop.order.refunded',
    'shop.stock.low',
    'payments.payment.succeeded',
    'payments.payment.refunded',
    'payments.payment.failed',
    'forms.submitted',
    'auth.user.created',
    'funnels.lead.captured',
    'reviews.submitted',
];
exports.AUTOMATIONS_PLUGIN = {
    id: 'automations',
    version: '1.0.0',
    kind: 'capability',
    trust: 'first-party',
    title: 'Automations',
    description: 'When something happens on your site, do something: email, webhooks, discounts, notes, list signups.',
    icon: 'i-ph:lightning',
    agentCard: 'Automations: owner workflows (trigger → conditions → actions) managed with create_automation / list_automations; always confirm with the owner before creating one.',
    subscribes: [...exports.AUTOMATION_BUS_TRIGGERS],
    permissions: ['db:own-tables', 'email:send', 'network:owner-webhooks'],
};
